import './styles/main.css'
import { App } from './app'

// Initialize the application with neo-brutal theme as default
document.body.classList.add('neobrutal')

const app = new App()
app.init() 